import axiosInstance from "../../services/AxiosInstance";
import { showErrorAlert, handleSuccess } from "../../services/ErrorHandlingService";

export const sendGenderFormLinkAction = (patientId, form) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("/patient/sendGenderFormLink", {
      patient_id: patientId,
      form: form,
    });

    if (response.data?.status === "success") {
      handleSuccess(response.data.message || "Link sent successfully");
    } else {
      showErrorAlert(response.data.message || "Failed to send link");
    }
  } catch (error) {
    showErrorAlert(error.response?.data?.message || error.message || "Something went wrong while sending link");
  }
};
